import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Visible breadcrumb trail. Pairs with the BreadcrumbList JSON-LD that
 * route-meta.js / generate-static-routes.js inject, giving users and crawlers
 * a clear path back up the hierarchy. (Publisher-readiness Phase 2.4)
 *
 * items: [{ name, to }] — the last item is rendered as the current page.
 */
export default function Breadcrumbs({ items = [], className = '' }) {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className={`text-xs sm:text-sm text-slate-500 ${className}`}
    >
      <ol className="flex items-center flex-wrap gap-1">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={item.to || item.name} className="flex items-center gap-1">
              {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-300 flex-shrink-0" />}
              {last || !item.to ? (
                <span className="text-slate-700 font-medium" aria-current="page">
                  {item.name}
                </span>
              ) : (
                <Link to={item.to} className="hover:text-blue-600 transition-colors">
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
